import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { MiniStoreThemeContext } from "../../../MiniStoreContexts/MiniStoreThemeContext";
import { Rating } from "react-simple-star-rating";
import { HiShoppingBag } from "react-icons/hi2";
import { CartContext } from "../../../contexts/MiniStore/CartContext";
import useVariantManager from "../../../contexts/MiniStore/useVariantManager";

const ProductCardModal = ({
  id,
  title,
  rating,
  quantity,
  price,
  newPrice,
  has_discounted_price,
  img,
  currency,
  description,
  onRatingChange,
  onQuantityChange,
  onAddToCart,
  onClick,
  fromShop = false,
}) => {
  const { theme } = useContext(MiniStoreThemeContext);
  const { cart } = useContext(CartContext);
  const [isLoadingAddToBag, setIsLoadingAddToBag] = useState(false);
  const [isLoadingAddIcons, setIsLoadingAddIcons] = useState(false);
  const {
    selectedAttributes,
    handleAttributeChange,
    availableOptions,
    selectedVariant,
    setSelectedVariant,
  } = useVariantManager();

  const handleAddToCart = async () => {
    setIsLoadingAddToBag(true);
    // console.log(
    //   "selected variant on add to cart",
    //   selectedVariant?.id,
    //   selectedVariant
    // );
    await onAddToCart({ productId: selectedVariant?.id });
    setIsLoadingAddToBag(false);
  };
  const increaseQty = async () => {
    setIsLoadingAddIcons(true);
    await onQuantityChange({
      productId: selectedVariant ? selectedVariant.id : id,
      qtyChange: 1,
    });
    setIsLoadingAddIcons(false);
  };
  const decreaseQty = async () => {
    setIsLoadingAddIcons(true);
    // console.log("quantity", quantity);
    // if (quantity > 1)
    if (
      selectedVariant
        ? cart.find((item) => item.id === selectedVariant.id)?.quantity > 0
        : quantity > 0
    )
      await onQuantityChange({
        productId: selectedVariant ? selectedVariant.id : id,
        qtyChange: -1,
      });
    setIsLoadingAddIcons(false);
  };
  useEffect(() => {
    // console.log("selected variant when change", selectedVariant);
  }, [selectedVariant]);

  if (fromShop) {
    return (
      <Card theme={theme} id={id} onClick={onClick}>
        <ShopViewWrapper>
          <Img src={img} />
          <Title>{title}</Title>
        </ShopViewWrapper>
      </Card>
    );
  }

  return (
    <Card theme={theme} id={id}>
      <ViewWrapper>
        <Img
          src={selectedVariant ? selectedVariant.image_1920 : img}
          onClick={onClick}
        />
        <InfoWrapper>
          <Title onClick={onClick}>{title}</Title>
          {/* {Object.keys(availableOptions).length > 0 && selectedVariant && ( */}
          <details>
            <summary>
              <strong>Description</strong>
            </summary>
            <p style={{ maxWidth: "250px" }}>
              {selectedVariant?.description || description}
            </p>
          </details>
          {/* )} */}
          {Object.keys(availableOptions).length > 0 && (
            <VariantSelector>
              {Object.entries(availableOptions).map(
                ([attributeName, options]) => (
                  <div
                    className="d-flex flex-column align-items-start justify-content-between"
                    key={attributeName}
                    style={{
                      flex: "1 1 calc(33.33% - 10px)",
                      maxWidth: "calc(33.33% - 10px)",
                      boxSizing: "border-box",
                      maxWidth: "max-content",
                    }}
                  >
                    <label>{attributeName}:</label>
                    <select
                      value={selectedAttributes[attributeName] || ""}
                      onChange={(e) =>
                        handleAttributeChange(attributeName, e.target.value)
                      }
                      style={{ maxWidth: "max-content" }}
                    >
                      {options.map(({ value_id, value_name }) => (
                        <option key={value_id} value={value_id}>
                          {value_name}
                        </option>
                      ))}
                    </select>
                  </div>
                )
              )}
              {!selectedVariant && (
                <div className="alert alert-warning" role="alert">
                  This combination does not exist!
                </div>
              )}
            </VariantSelector>
          )}
          <>
            <RatingContainer>
              <Rating
                initialValue={
                  selectedVariant ? selectedVariant.rating : rating || 0
                }
                readonly
                size={20}
              />
            </RatingContainer>
            <PriceContainer>
              {Number(selectedVariant?.newPrice) <
                Number(selectedVariant?.price) &&
              selectedVariant?.has_discounted_price ? (
                <>
                  <Price theme={theme}>{selectedVariant?.currency}</Price>
                  <OverlinedPrice theme={theme}>
                    {selectedVariant?.price}
                  </OverlinedPrice>
                  <Price theme={theme}>{selectedVariant?.newPrice}</Price>
                </>
              ) : (
                <Price theme={theme}>
                  {selectedVariant?.currency} {selectedVariant?.newPrice}
                </Price>
              )}
              {/* <Currency theme={theme}>
                {selectedVariant ? selectedVariant.currency : currency}
              </Currency>
              <Price theme={theme}>
                {selectedVariant ? selectedVariant.newPrice : newPrice}
              </Price> */}
            </PriceContainer>
            <ControlsContainer>
              <QuantityControl theme={theme}>
                <Icon
                  disabled={isLoadingAddIcons}
                  theme={theme}
                  className="fa-solid fa-minus"
                  onClick={decreaseQty}
                />
                <Count theme={theme}>
                  {selectedVariant
                    ? cart.find((item) => item.id === selectedVariant.id)
                        ?.quantity || 0
                    : quantity}
                </Count>
                <Icon
                  disabled={isLoadingAddIcons}
                  theme={theme}
                  className="fa-solid fa-plus"
                  onClick={handleAddToCart}
                  // onClick={increaseQty}
                />
              </QuantityControl>
              <AddToBagButton
                theme={theme}
                disabled={isLoadingAddToBag}
                onClick={handleAddToCart}
              >
                Add
              </AddToBagButton>
            </ControlsContainer>
          </>
        </InfoWrapper>
      </ViewWrapper>
    </Card>
  );
};

export default ProductCardModal;

// Styled Components
const VariantSelector = styled.div`
  margin: 10px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-items: start;
  gap: 8px;
  label {
    font-weight: bold;
    margin-right: 10px;
  }
  select {
    padding: 5px;
    border-radius: 0.15rem;
    border: 1px solid #ccc;
    width: 100%;
  }
`;
const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: #fff;
  padding: 0px 16px 16px 16px;
  border-radius: 0.15rem;
  width: 100%;
  // transition: transform 0.2s ease-in-out;

  // &:hover {
  //   transform: translateY(-5px);
  // }
`;
const CartIcon = styled(HiShoppingBag)`
  color: ${({ theme }) => theme.textColor.primary};
  font-size: 26px;
  &:hover {
    color: ${({ theme }) => theme.textColor.secondary};
  }
`;
const Img = styled.img`
  height: 248px;
  width: 248px;
  max-width: 100%;
  border-radius: 0.15rem;
  @media (max-width: 527px) {
    height: 265px;
    width: 265px;
  }
`;
const Title = styled.div`
  font-family: Outfit, sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 29px;
  width: 100%;
  display: flex;
  justify-content: start;
  padding-top: 0.5rem;
`;
const RatingContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
`;
const OverlinedPrice = styled.span`
  text-decoration: line-through;
  color: #9c9a9a;
  ont-family: Outfit;
  font-size: 18px;
  line-height: 29px;
  font-weight: 700;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
`;
const PriceContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin: 0.5rem 0rem;
`;
const Currency = styled.div`
  ont-family: Outfit;
  font-size: 18px;
  line-height: 29px;
  font-weight: 700;
  color: ${({ theme }) => theme.primaryColor.primary};
`;
const Price = styled.div`
  ont-family: Outfit;
  font-size: 18px;
  line-height: 29px;
  font-weight: 700;
  color: ${({ theme }) => theme.primaryColor.primary};
`;
const ControlsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  justify-content: space-between;
  align-items: start;
`;
const QuantityControl = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  // box-shadow: ${({ theme }) => theme.boxShadow.primary};
  padding: 5px 10px;
  border-radius: 0.15rem;
  border-width: 1px;
  border: 1px solid #dee2e6;
  width: 100%;
  // max-width: 165px;
  @media (max-width: 527px) {
    max-width: 100%;
  }
`;
const Count = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.primaryColor.primary};
  margin: 0 10px;
  width: 100%;
  text-align: center;
`;
const Icon = styled.i`
  cursor: pointer;
  color: #fff;
  background: ${({ theme }) => theme.primaryColor.primary};
  border-radius: 0.15rem;
  padding: 2px;
`;
const AddToBagButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: ${({ theme }) => theme.primaryColor.primary};
  color: ${({ theme }) => theme.textColor.primary};
  border: none;
  padding: 8px 16px;
  border-radius: 0.15rem;
  cursor: pointer;
  font-weight: 600;
  font-size: 16px;
  font-family: Outfit, sans-serif;
  transition: background 0.2s ease-in-out;
  width: 100%;
  &:hover {
    background: ${({ theme }) => theme.primaryColor.secondary};
    color: ${({ theme }) => theme.textColor.secondary};

  svg {
    color: ${({ theme }) => theme.textColor.secondary};
  }
`;
const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  @media (max-width: 527px) {
    width: 100%;
  }
`;

const ViewWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: row-reverse;
  gap: 30px;
  justify-content: start;
  max-width: 100%;
  @media (max-width: 527px) {
    gap: 10px;
    flex-direction: column;
  }
`;
const ShopViewWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 15px;
`;
